import React, {useEffect, useRef, useState} from 'react';
import {
  Modal, Box,
  Button,
  Card,
  CardContent,
  CardActions,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Tab,
  Tabs,
  TextField,
  Typography, makeStyles, Grid, IconButton, InputAdornment, LinearProgress, CircularProgress
} from "@material-ui/core";
import NotificationLookup from "./NotificationLookup";
import {getScreenList, getRouterList, getFCMTopicList} from "../../Services/pushNotif";
import Autocomplete from '@material-ui/lab/Autocomplete';
import {Notifications, Send, CloudUpload, Delete} from "@material-ui/icons";
import {DateTimePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import imageCompression from 'browser-image-compression';
import {updatePushNotification, uploadFileSingle} from "../../Services/pushNotif"
import {addPushNotification} from "../../Services/pushNotif";
import idLocale from 'date-fns/locale/id';
import {id} from "date-fns/locale";

const useStyles = makeStyles((theme) => ({
  paper: {
    left: "50%",
    transform: "translate(-50%, 0)",
    position: "absolute",
    width: 600,
    height: "calc(100% - 100px)",
    outline: "none",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
    paddingTop: theme.spacing(2),
    borderRadius: 15,
    margin: `${theme.spacing(4)}px 0`,
    overflowY: "auto",
  },
  upper: {
    paddingTop: 20,
  },
  divImage: {
    justifyContent: 'center',
    alignItems: 'center',
    width: 300,
    height: 300,
    overflow: "hidden",
  },
  logo: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  image: {
    maxWidth: "100%",
    maxHeight: "100%",
  },
  helperTextOverride: {
    paddingLeft: 0,
  },
}));

const FCMComposer = (props) => {
  const classes = useStyles();
  const { open, onClose, composerData, mode = 'add' } =
    props;
  const [config, setConfig] = useState({});
  const [configErrors, setConfigErrors] = useState({});
  const screens = config.screens || [];
  const routers = config.routers || [];
  const fcmTopicList = config.topics || [];
  const configRequests = {screens: getScreenList, routers: getRouterList, topics: getFCMTopicList};
  const loadConfig = (key) => {
    setConfigErrors(previous => ({...previous, [key]: false}));
    configRequests[key]().then(res => setConfig(previous => ({...previous, [key]: res.data})))
      .catch(() => setConfigErrors(previous => ({...previous, [key]: true})));
  };
  useEffect(() => {
    Object.keys(configRequests).forEach(loadConfig);
  }, []);
  // Message state
  const [messageType, setMessageType] = useState('notification');
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');
  const [selectedTopics, setSelectedTopics] = useState([]);
  const [token, setToken] = useState('');
  const [targetType, setTargetType] = useState('topic');
  
  // Data payload state
  const [dataPayload, setDataPayload] = useState('{}');
  const [isLoading, setIsLoading] = useState(false);
  
  // Notification options
  const [clickAction, setClickAction] = useState('');
  const [priority, setPriority] = useState('high');
  const [scheduledAt, setScheduledAt] = useState(null);
  
  // Advanced options, not used yet
  const [collapseKey, setCollapseKey] = useState('');
  const [contentAvailable, setContentAvailable] = useState(false);
  const [mutableContent, setMutableContent] = useState(false);
  
  // Image related
  const fileInputRef = useRef(null);
  const [fileName, setFileName] = useState("");
  const [imageUrl, setImageUrl] = useState('');
  const [uploading, setUploading] = useState(false);
  const [image, setImage] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [previewSrc, setPreviewSrc] = useState('');
  
  // Screen info
  const [selectedScreen, setSelectedScreen] = useState(false);
  const [selectedRouter, setSelectedRouter] = useState('HomeNavigation');
  const [selectedPromo, setSelectedPromo] = useState(null);
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null);
  
  
  const handleUrlInput = async (url) => {
    if (!url) {
      setImage(null);
      setFileName(null);
      setPreviewSrc(null);
    }
    setImageUrl(url);
    if (!url || !/^https?:\/\//.test(url)) return;
    
    try {
      setUploading(true);
      setUploadProgress(0);
      
      const response = await fetch(url);
      const blob = await response.blob();
      
      const file = new File([blob], url, {
        type: blob.type,
        lastModified: Date.now(),
      });
      
      const compressedFile = await imageCompression(file, {
        useWebWorker: true,
        maxSizeMB: 0.1,
        preserveExif: true,
        onProgress: (percent) => setUploadProgress(percent),
      });
      
      const newFile = new File([compressedFile], file.name, {
        type: compressedFile.type,
        lastModified: Date.now(),
      });
      
      const reader = new FileReader();
      reader.readAsDataURL(newFile);
      reader.onloadend = () => {
        setPreviewSrc(reader.result);
        setImage(newFile);
        setFileName(newFile.name);
        setUploading(false);
      };
    } catch (error) {
      console.error('Image download failed:', error);
      setUploading(false);
    }
  };
  
  
  const handleFileChange = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    
    setUploading(true);
    setUploadProgress(0);
    
    const compressedFile = await imageCompression(file, {
      useWebWorker: true,
      maxSizeMB: 0.1,
      preserveExif: true,
      onProgress: (percent) => setUploadProgress(percent),
    });
    
    const newFile = new File([compressedFile], file.name, {
      type: compressedFile.type,
      lastModified: Date.now()
    });
    
    const reader = new FileReader();
    reader.readAsDataURL(newFile);
    reader.onloadend = () => {
      setPreviewSrc(reader.result);
      setImage(newFile);
      setFileName(newFile.name);
      setUploading(false);
    };
  };
  
  const [activeTab, setActiveTab] = useState(0);
  
  const isJsonValid = (str) => {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  };
  
  const handleDataPayloadChange = (e) => {
    setDataPayload(e.target.value);
  };
  
  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const customParams = isJsonValid(dataPayload) ? JSON.parse(dataPayload) : {};
      const data = {
        screen: selectedScreen,
        router: selectedRouter,
        params: customParams,
        scheduledAt
      };
      
      if (image) {
        try {
          const uploadImageResult = await uploadFileSingle(image);
          data.imageUrl = uploadImageResult?.url;
        } catch (err) {
          console.error(err);
        }
      }
      
      let topicField = {};
      if (targetType === 'topic') {
        if (selectedTopics.length > 1) {
          const conditionStr = selectedTopics.map(t => `'${t}' in topics`).join(' && ');
          topicField = {
            targetType: 'condition',
            targetValue: conditionStr,
          };
        } else if (selectedTopics.length === 1) {
          topicField = {
            targetType: 'topic',
            targetValue: selectedTopics[0],
          };
        }
      } else if (targetType === 'token') {
        topicField = {
          targetType: 'token',
          targetValue: token,
        };
      }
      
      
      // Build message object
      const payload = {
        title,
        body,
        imageUrl: data.imageUrl || imageUrl,
        scheduledAt,
        priority,
        router: selectedRouter,
        screen: selectedScreen,
        params: customParams,
        topics: selectedTopics,
        ...topicField,
      };
      
      await (mode === 'edit'
        ? updatePushNotification(composerData.id, payload)
        : addPushNotification(payload));
      
    } catch (error) {
      console.error('Error building message:', error);
    } finally {
      setIsLoading(false);
      onClose()
    }
  };
  
  useEffect(() => {
    if (mode === "edit" && composerData) {
      setMessageType('notification'); // if dynamic, use composerData.messageType
      setTitle(composerData.title || '');
      setBody(composerData.body || '');
      setImageUrl(composerData.imageUrl || '');
      setPriority(composerData.priority || 'high');
      setScheduledAt(composerData.scheduledAt ? new Date(composerData.scheduledAt) : null);
      setSelectedRouter(composerData.router || '');
      setSelectedScreen(composerData.screen || '');
      setDataPayload(JSON.stringify(composerData.params || {}, null, 2));
      setSelectedPromo(composerData.params?.promo?.id ? {id: composerData.params?.promo?.id} : null);
      setSelectedArticle(composerData.params?.data?.Articles?.id ? {id: composerData.params?.data?.Articles?.id} : null);
      setSelectedEvent(composerData.params?.event?.id ? {id: composerData.params?.event?.id} : null);

      if (composerData.targetType === 'token') {
        setTargetType('token');
        setToken(composerData.targetValue);
      } else if (composerData.targetType === 'topic') {
        setTargetType('topic');
        setSelectedTopics([composerData.targetValue]);
      } else if (composerData.targetType === 'condition') {
        setTargetType('topic');
        const matches = composerData.targetValue?.match(/'([^']+)'/g) || [];
        const topics = matches.map(m => m.replace(/'/g, ''));
        setSelectedTopics(topics);
      }
    }

  }, [mode, composerData]);
  
  const chooseReference = (type, value) => {
    const setters = {promo: setSelectedPromo, article: setSelectedArticle, event: setSelectedEvent};
    setters[type](value);
    const current = isJsonValid(dataPayload) ? JSON.parse(dataPayload) : {};
    if (type === 'article') {
      current.data = {...current.data};
      if (value) current.data.Articles = {id: value.id};
      else delete current.data.Articles;
    } else if (value) current[type] = {id: value.id};
    else delete current[type];
    setDataPayload(JSON.stringify(current, null, 2));
  };

  return (
   <Grid>
     <Modal open={open} onClose={onClose}>
       <div
         className={classes.paper}
       >
           <CardContent>
             <Box
               display="flex"
               flexDirection="row"
               alignItems="center"
               mb={2}
             >
               <Notifications color="primary" style={{ marginRight: 8 }} />
               <Typography variant="h5" component="h2">
                 FCM Message Composer
               </Typography>
             </Box>
             
             {Object.keys(configErrors).filter(key => configErrors[key]).map(key => <Button key={key} onClick={() => loadConfig(key)}>Retry {key}</Button>)}
             <Tabs
               value={activeTab}
               onChange={(e, newValue) => setActiveTab(newValue)}
               style={{ mb: 2 }}
             >
               <Tab label="Message" />
               <Tab label="Options" />
               <Tab label="Redirection" />
             </Tabs>
             
             {activeTab === 0 && (
               <Box>
                 <FormControl fullWidth margin="normal">
                   <InputLabel>Message Type</InputLabel>
                   <Select
                     value={messageType}
                     onChange={(e) => setMessageType(e.target.value)}
                     label="Message Type"
                     disabled
                   >
                     <MenuItem value="notification">Notification</MenuItem>
                     <MenuItem value="data">Data Only</MenuItem>
                   </Select>
                 </FormControl>
                 
                 {messageType === 'notification' && (
                   <>
                     <TextField
                       id="notification-title"
                       label="Title"
                       fullWidth
                       margin="normal"
                       value={title}
                       onChange={(e) => setTitle(e.target.value)}
                     />
                     <TextField
                       id="notification-body"
                       label="Body"
                       fullWidth
                       margin="normal"
                       multiline
                       rows={3}
                       value={body}
                       onChange={(e) => setBody(e.target.value)}
                     />
                   </>
                 )}
                 
                 <Divider style={{ my: 2 }} />
                 
                 <FormControl fullWidth margin="normal">
                   <InputLabel>Target Type</InputLabel>
                   <Select
                     value={targetType}
                     onChange={(e) => setTargetType(e.target.value)}
                     label="Target Type"
                   >
                     <MenuItem value="topic">Topic</MenuItem>
                     <MenuItem value="token">Device Token</MenuItem>
                   </Select>
                 </FormControl>
                 
                 {targetType === 'topic' ? (
                   <Autocomplete
                     multiple
                     options={fcmTopicList}
                     loading={!config.topics && !configErrors.topics}
                     value={selectedTopics}
                     onChange={(event, newValue) => setSelectedTopics(newValue)}
                     filterSelectedOptions
                     renderInput={(params) => (
                       <TextField
                         {...params}
                         label="Topics"
                         margin="normal"
                         fullWidth
                         placeholder="Choose topics"
                         helperText="Select one or more topics (AND condition)"
                         FormHelperTextProps={{
                           classes: {
                             root: classes.helperTextOverride
                           }
                         }}
                       />
                     )}
                   />
                 ) : (
                   <TextField
                     label="Device Token"
                     fullWidth
                     margin="normal"
                     value={token}
                     onChange={(e) => setToken(e.target.value)}
                   />
                 )}
               </Box>
             )}
             
             {/* Options Tab */}
             {activeTab === 1 && (
               <Box>
                 <TextField
                   variant={"outlined"}
                   label="Click Action"
                   fullWidth
                   margin="normal"
                   value={clickAction}
                   onChange={(e) => setClickAction(e.target.value)}
                   helperText="(Optional) For android intent filter"
                   FormHelperTextProps={{
                   classes: {
                     root: classes.helperTextOverride
                   }
                 }}
                 />
                 
                 <Box style={{marginTop: 2}}>
                   <TextField
                     label="Notification Image"
                     variant="outlined"
                     fullWidth
                     margin="normal"
                     value={imageUrl}
                     onChange={(e) => handleUrlInput(e.target.value)}
                     helperText= "(Optional) Image to display in the notification"
                     InputProps={{
                       endAdornment: (
                         <InputAdornment position="end">
                           <IconButton onClick={() => fileInputRef.current?.click()}>
                             <CloudUpload />
                           </IconButton>
                         </InputAdornment>
                       ),
                     }}
                     FormHelperTextProps={{
                       classes: {
                         root: classes.helperTextOverride
                       }
                     }}
                   />
                   <input
                     type="file"
                     accept="image/*"
                     hidden
                     ref={fileInputRef}
                     onChange={handleFileChange}
                   />
                   
                   {uploading && (
                     <Box sx={{ mt: 1 }}>
                       <Typography variant="body2" color="textSecondary">{`Upload & compress ${uploadProgress}%...`}</Typography>
                       <LinearProgress variant="determinate" value={uploadProgress} />
                     </Box>
                   )}
                   
                   {fileName && (
                     <span
                       style={{
                         marginTop: 8,
                         display: 'flex',
                         alignItems: 'center',
                         justifyContent: 'space-between',
                         gap: 8,
                       }}
                     >
                        <Typography variant="body2" style={{ marginRight: 8 }}>
                          Uploaded: {fileName}
                        </Typography>
                        <IconButton
                          color="secondary"
                          size="small"
                          onClick={() => {
                            setFileName('');
                            setImage(null);
                            setPreviewSrc('');
                            if (fileInputRef.current) {
                              fileInputRef.current.value = null;
                            }
                          }}
                        >
                          <Delete fontSize="small" />
                        </IconButton>
                      </span>
                   )}
                   
                   {previewSrc && (
                     <Box
                       style={{
                         marginTop: 2,
                         width: 300,
                         height: 300,
                         borderRadius: 1,
                         overflow: 'hidden',
                         border: '1px solid #ccc',
                         display: 'flex',
                         justifyContent: 'center',
                         alignItems: 'center',
                       }}
                     >
                       <img
                         src={previewSrc}
                         alt="Preview"
                         style={{
                           width: '100%',
                           height: '100%',
                           objectFit: 'contain',
                         }}
                       />
                     </Box>
                   )}
                 </Box>
                 
                 <FormControl fullWidth margin="normal">
                   <InputLabel>Priority</InputLabel>
                   <Select
                     value={priority}
                     onChange={(e) => setPriority(e.target.value)}
                     label="Priority"
                   >
                     <MenuItem value="high">High</MenuItem>
                     <MenuItem value="normal">Normal</MenuItem>
                   </Select>
                 </FormControl>
                 
                 <MuiPickersUtilsProvider utils={DateFnsUtils} locale={id}>
                   <DateTimePicker
                     label="Schedule At"
                     format="dd MMMM yyyy, HH:mm"
                     placeholder="Optional"
                     inputVariant="outlined"
                     value={scheduledAt}
                     onChange={(date) => setScheduledAt(date)}
                     fullWidth
                     minDate={Date.now()}
                     margin="normal"
                     ampm={false}
                     clearable
                     disablePast
                     helperText="(Optional) Pick date and time to schedule the message"
                     FormHelperTextProps={{ style: { paddingLeft: 0 } }}
                   />
                 </MuiPickersUtilsProvider>
               </Box>
             )}
             
             {activeTab === 2 && (
               <Box>
                 <Autocomplete
                   disablePortal
                   options={routers}
                   fullWidth
                   value={selectedRouter}
                   disabled={true}
                   renderInput={(params) => <TextField {...params} label="Router Name" margin="normal" />}
                   onChange={(_, newValue) => setSelectedRouter(newValue || '')}
                 />
                 
                 <Autocomplete
                   disablePortal
                   options={screens}
                   loading={!config.screens && !configErrors.screens}
                   fullWidth
                   value={selectedScreen}
                   renderInput={(params) => <TextField {...params} label="Screen Name" margin="normal" />}
                   onChange={(_, newValue) => {
                     setSelectedScreen(newValue);
                     setDataPayload(JSON.stringify({}, null, 2));
                     if (newValue !== 'PromoDetail') {
                       setSelectedPromo(null);
                     }
                     if (newValue !== 'ArticleDetail') {
                       setSelectedArticle(null);
                     }
                     if (newValue !== 'EventDetail') {
                       setSelectedEvent(null);
                     }
                   }}
                 />
                 {selectedScreen === 'PromoDetail' && <NotificationLookup type="promo" value={selectedPromo} onChange={value => chooseReference('promo', value)} />}
                 {selectedScreen === 'ArticleDetail' && <NotificationLookup type="article" value={selectedArticle} onChange={value => chooseReference('article', value)} />}
                 {selectedScreen === 'EventDetail' && <NotificationLookup type="event" value={selectedEvent} onChange={value => chooseReference('event', value)} />}
                 <TextField
                   label="Custom Params (Advance Feature)"
                   fullWidth
                   margin="normal"
                   disabled={!!selectedPromo || !!selectedArticle || !!selectedEvent || selectedScreen == 'Promo'}
                   multiline
                   rows={4}
                   value={dataPayload}
                   onChange={handleDataPayloadChange}
                   error={!isJsonValid(dataPayload)}
                   helperText={!isJsonValid(dataPayload) ? 'Invalid JSON format' : 'Custom parameters for navigation'}
                   InputProps={{
                     sx: { fontFamily: 'monospace' }
                   }}
                   FormHelperTextProps={{ style: { paddingLeft: 0 } }}
                 />
               </Box>
             )}
           </CardContent>
           
           <CardActions style={{ justifyContent: 'flex-end', padding: 2 }}>
             <Button
               variant="contained"
               color="primary"
               startIcon={ isLoading ? null : <Send />}
               onClick={handleSubmit}
               disabled={
                 (messageType === 'notification' && (!title || !body)) ||
                 (targetType === 'topic' && !selectedTopics.length) ||
                 (targetType === 'token' && !token) ||
                 !isJsonValid(dataPayload)
               }
             >
               {isLoading ? <CircularProgress/> : mode === 'edit' ? 'Update Message' : 'Deliver Message'}
             </Button>
           </CardActions>
       </div>
     </Modal>
   </Grid>
  );
};

export default FCMComposer;
